var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.setClass},[(_vm.isEmpty)?_c('div',{staticClass:"empty-list--inner"},[_c('i',{staticClass:"ico--empty-data"}),_c('p',[_vm._v(_vm._s(_vm.common[_vm.lang]['no_data_found']))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }